import React, { useRef, useState } from "react";


function HabitInput(props) {
    const { habit,setHabit } = props;

    const [ searchDisabled, setSearchDisabled ] = useState(true);

    const inputRef = useRef('');

    const onChangeHandler = (e) => {
        setSearchDisabled(!e.target.value);
    }

    const handleClick = (e) => {
        e.preventDefault();
        
        const newHabit = {
            name: inputRef.current.value,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
        };

        const habits = {...habit};
        habits[`habit-${Date.now()}`] = newHabit

        setHabit(habits);

        inputRef.current.value = '';

        setSearchDisabled(true);
    }

    return (
        <form className="habit-form">
            <input type="text" maxlength="30" ref={inputRef} onChange={(e) => {onChangeHandler(e)}}></input>
            <button type="submit" onClick={handleClick} disabled={searchDisabled}>Add</button>
        </form>
    )
}

// disable da search button if input field empty

export default HabitInput;